import React from "react";
import Whatsapp from "../../../../assets/images/Whatsapp.svg";
import Instagram from "../../../../assets/images/Instagram.svg";
import Telegram from "../../../../assets/images/Telegram.svg";
import Facebook from "../../../../assets/images/facebook-512.svg";
import Header from "../../../../containers/Header";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import { useSelector } from "react-redux";
import BottomNav from "../../../../containers/BottomNav";

const BeforeContactUs = () => {
  const { appDetails } = useSelector((state) => state.app);
  return (
    <>
      <Header />

      <main className="main">
        <div className="container">
          <h2 className="sectionTitle">Contact Us</h2>
          <div className="payment-info">
            <div class="social-icons contact-social">
              <ul>
                <li>
                  <a
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "javascript:void(0)"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={Whatsapp} alt="Whatsapp" />
                  </a>
                </li>
                <li>
                  <a
                    href={
                      appDetails?.INSTATGRAM != ""
                        ? appDetails?.INSTATGRAM
                        : "javascript:void(0)"
                    }
                    target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Instagram} alt="Instagram" />
                  </a>
                </li>
                <li>
                  <a
                    href={
                      appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Telegram} alt="Telegram" />
                  </a>
                </li>
                <li>
                  <a
                    href={
                      appDetails?.FACEBOOK != ""
                        ? appDetails?.FACEBOOK
                        : "javascript:void(0)"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img src={Facebook} alt="Facebook" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <BeforeLoginFooter />
      <BottomNav />
    </>
  );
};

export default BeforeContactUs;
